import BaseModel from "./base/baseModel";
import ConfiguracaoAtendimentoHorario from "./configuracaoAtendimentoHorarioModel";
import TipoAlocacaoAtendimento from "./enum/tipoAlocacaoAtendimento";
import ConfiguracaoUsuarioAtendimentoModel from "./whatsApp/configuracaoUsuarioAtendimentoModel";

export default class ConfiguracaoAtendimentoModel extends BaseModel {
    id?: number = null;
    tipoAlocacaoAtendimento: TipoAlocacaoAtendimento;
    configuracaoUsuarios: Array<ConfiguracaoUsuarioAtendimentoModel> = [];
    configuracaoAtendimentoHorario: ConfiguracaoAtendimentoHorario[] = [];
}
